import React, { useState, useEffect, useContext, useRef } from 'react';
import { UserAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Button, Modal } from 'react-bootstrap';
import ProfileContext from '../context/ProfileContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import googleIcon from '../assets/google-icon.svg'
import axios from 'axios';
import { useUserContext } from '../context/UserContext';
import { Loaderpage } from '../components/Loader';
import GooglePopupOverlay from '../components/GooglePopupOverlay';

const Signin = () => {
  const { userData, handleUserChange } = useUserContext();
  const { setProfile, profile } = useContext(ProfileContext);
  const [alertshow, setAlertShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [preferedLang, setPreferedLang] = useState('');
  const [isSigned, setIssined] = useState(false);
  const [showModal, setshowmodal] = useState(false)
  const hasChecked = useRef(false);

  const [reqId, setReqId] = useState(null);
  const [interviewType, setInterviewtype] = useState(null)
  const [jobTitle, setJobTitle] = useState(null)
  const [showInstructionModal, setShowInstructionModal] = useState(false);
  // End: Profile Page Code

  const { googleSignIn, user, authReady, isFormSub, googleSignedUser, removedata } = UserAuth();
  const navigate = useNavigate();

  const [popupOpened, setPopupOpened] = useState(false);

  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem('hasSeenInstructionModal');
    if (!hasSeenModal) {
      setShowInstructionModal(true);
      sessionStorage.setItem('hasSeenInstructionModal', 'true');
    }
  }, []);
  // handleMSSignIn
  // const handleMSSignIn = async () => {
  //   try {
  //     await microsoftSignIn();
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  // handleMSSignIn

  const handleGoogleSignIn = async () => {
    try {
      setPopupOpened(true);
      await googleSignIn();
      setPopupOpened(false);
    } catch (error) {
      setPopupOpened(false);
    }
  };

  //For Already Signed IN users
  const handleSignIn = async () => {
    try {
      setIssined(true);
      setPopupOpened(true); // ✅ overlay show karo
      await googleSignedUser();
      setPopupOpened(false); // ✅ automatic hide
    } catch (error) {
      // console.log(error);
      setIssined(false);
      setPopupOpened(false); // ✅ error pe hide karo
    }
  };

  const saveData = async () => {
    // alert("hello!")
    let mysqlTimestamp = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');

    const InterviewerInfo = {
      display_name: user?.displayName,
      email: user?.email,
      contact_no: user?.phoneNumber,
      profile_img: user?.photoURL,
      prefered_lang: preferedLang?.value || null,
      login_datetime: mysqlTimestamp,
      login_token: user?.uid,
      lang_id: preferedLang?.id,
      fromCareer: userData?.getReqId ? true : false,
      req_id: userData?.getReqId || "",
      technical_round: userData?.getInterviewtype === 'technical' ? 1 : 0,
      one2one_round: (userData?.getInterviewtype === 'non-technical' || userData?.getInterviewtype === 'technical') ? 1 : 0,
      source_of_candidate: userData?.source_of_candidate || null,
    };
    // console.log(InterviewerInfo)
    // return;
    setProfile(InterviewerInfo);
    const apiUrl =
      `${process.env.REACT_APP_FRONTEND}/api/v4.0/candidate-info/signin`;
    try {
      setIsLoading(true);
      const refreshedToken = await user?.getIdToken();
      const fetchResponse = await axios.post(`${process.env.REACT_APP_FRONTEND}/api/v4.0/candidate-info/fetchuser`, {
        operation: 'fetchuser',
        email: user?.email,
      }, {
        headers: {
          'Authorization': `Bearer ${refreshedToken}`,
          'Content-Type': 'application/json',
        },
      });

      const dataVal = fetchResponse.data.data;
      if (dataVal && dataVal.length > 0) {
        setIsLoading(false);
        fetchUserInfo(user);
        return;
      }
      const response = await axios.post(apiUrl, InterviewerInfo, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${refreshedToken}`
        }
      });
      setIsLoading(false);
      // Registration successful — Account.js fetches full profile on mount; no need to fetch here.
      navigate('/account');
    } catch (error) {
      setIsLoading(false);
      console.error('Error:', error);
      // Show modal on error too — user cannot proceed without proper invitation
      setAlertShow(true);
    }
  };

  const onCloseAlert = async () => {
    setAlertShow(false);
    removedata(); // Sign out the user when they dismiss the modal
  }

  useEffect(() => {
    // Fix: do not redirect until Firebase has restored the session on refresh
    if (!authReady) {
      return;
    }

    if (!user?.uid) {
      hasChecked.current = false;
      return;
    }
    if (hasChecked.current) return;

    // Set synchronously to prevent race conditions during async calls
    hasChecked.current = true;

    const handleUserEffects = async () => {
      if (isFormSub) {
        saveData();
      } else if (isSigned) {
        await fetchUserInfo(user);
      } else {
        await fetchUserInfo(user);
        navigate('/account');
      }
    };
    handleUserEffects();
  }, [authReady, user?.uid, isFormSub, isSigned, navigate]);



  const fetchUserInfo = async (user) => {
    handleUserChange("isRegistered", 'no');
    try {
      setIsLoading(true);
      let mysqlTimestamp = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');
      const refreshedToken = await user?.getIdToken(); // Assuming you have the refreshed token available
      const headers = {
        'Authorization': `Bearer ${refreshedToken}`,
        'Content-Type': 'application/json',
      };

      const response = await axios.post(`${process.env.REACT_APP_FRONTEND}/api/v4.0/candidate-info/fetchuser`, {
        operation: 'fetchuser',
        email: user?.email,
      }, {
        headers: headers,
      });
      setIsLoading(false);
      const dataVal = response.data.data;
      // console.log("dataVal", dataVal[0])
      if (dataVal.length === 0) {
        toast.error('Please sign up we do not have your account !');
        removedata()
        navigate('/' + window.location.search);
      } else {
        const userData = dataVal[0];
        handleUserChange("userId", userData?.id);
        if (userData && userData?.is_edu_added === 1 &&
          userData?.is_employement_added === 1 &&
          userData?.is_number_verified === 1 &&
          userData?.is_profile_verified === 1 &&
          userData?.resume_headline_added === 1) {
          navigate('/account')
          handleUserChange("redirectPage", 'yes');
          handleUserChange("isRegistered", 'yes');
          return;
        } else {
          const InterviewerInfo = {
            display_name: user?.displayName,
            email: user?.email,
            profile_img: user?.photoURL,
            prefered_lang: userData?.prefered_lang || null,
            login_datetime: mysqlTimestamp,
            login_token: user?.uid
          };
          if (user?.phoneNumber) {
            InterviewerInfo.contact_no = user.phoneNumber;
          }
          setProfile(InterviewerInfo);
          navigate('/account');
          handleUserChange("redirectPage", 'yes');
        }
        // oldCode
        // const InterviewerInfo = {
        //   display_name: user?.displayName,
        //   email: user?.email,
        //   contact_no: user?.phoneNumber,
        //   profile_img: user?.photoURL,
        //   current_company: userData?.current_company,
        //   total_exp: parseInt(userData?.total_exp),
        //   prefered_lang: userData?.prefered_lang || null,
        //   job_status: userData?.job_status,
        //   login_datetime: mysqlTimestamp,
        //   login_token: user?.uid
        // };
        // setProfile(InterviewerInfo);
        // navigate('/account');
        // oldCode
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };



  var settings = {
    arrows: false,
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const langArray = ["JavaScript", "Python", "Java", "C++", "PHP", "Ruby", "Swift", "Objective-C", "Go", "Kotlin", "C#", "Rust", "Scala", "Perl", "TypeScript", "SQL"];

  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const interviewTypeValue = atob(params.get("interviewType"))
  //   setInterviewtype(interviewTypeValue)
  //   const reqIdvalue = atob(params.get("reqId"))
  //   if(!reqIdvalue){
  //     return
  //   }
  //   setReqId(reqIdvalue)
  //   handleUserChange("getInterviewtype", interviewTypeValue)
  //   handleUserChange("getReqId", reqIdvalue)
  //   console.log("getReqId::", reqIdvalue)
  // }, []);

  const uuidToNumber = (uuid) => {
    const first = uuid.split("-")[0];
    const L = parseInt(first[0], 16);          // recover hex length
    const hexId = first.slice(8 - L);          // last L hex digits
    return parseInt(hexId, 16);
  }

  useEffect(() => {
    const fetchParams = async () => {
      const params = new URLSearchParams(window.location.search);
      try {
        // Decode jobType if available
        const interviewTypeEncoded = params.get("jobType");
        if (interviewTypeEncoded) {
          // const interviewTypeValue = atob(interviewTypeEncoded);
          const interviewTypeValue = interviewTypeEncoded
          // console.log("interviewTypeValue:", interviewTypeValue);
          setInterviewtype(interviewTypeValue);
          handleUserChange("getInterviewtype", interviewTypeValue);
        }

        // Decode reqId if available
        const reqIdEncoded = params.get("reqId");
        if (reqIdEncoded) {
          const reqIdValue = await uuidToNumber(reqIdEncoded);
          // console.log("reqIdValue:", reqIdValue);
          setReqId(reqIdValue);
          handleUserChange("getReqId", reqIdValue);
        }

        // Decode jobTitle
        const jobtitleValue = params.get("jobTitle");
        setJobTitle(jobtitleValue)

        // Decode source
        const sourceValue = params.get("source");
        if (sourceValue) {
          handleUserChange("source_of_candidate", sourceValue);
        }
      } catch (error) {
        console.error("Error decoding query params:", error);
      }
    };

    fetchParams();
  }, []);



  return (
    <div className='authentication-page'>
      {isLoading && <Loaderpage />}
      <div className='auth_page'>
        <div className='left-section d-flex flex-column bg-primary text-white'>
          <div className="info-wrapper d-flex flex-column justify-content-between flex-fill gap-4">
            <div className='logo-title text-uppercase small fw-bold'>
              <img className='img-fluid' src={require(`../assets/${process.env.REACT_APP_LOGO}`)} alt='Logo' />
              {/* <div className="app-version d-grid gap-1">
                <span className='d-block fw-normal mt-2 heading-subtitle'>BETA<span className='px-1 fw-normal'>Version {process.env.REACT_APP_VERSION}</span></span>
              </div> */}
            </div>

            <div className="middle-sec">
              <div className="badge-wrapper mb-3">
                <span className="badge rounded-pill text-bg-theme7 bg-opacity-25 border border-theme7 border-opacity-25 fw-normal text-theme7 px-2 py-1">🔒 Secure Interview Portal</span>
              </div>
              <div className="heading-title fs-3 fw-bold mb-3">Transforming Hiring with <span className="text-theme7">Intelligent</span> Interviews</div>
              <div className="fw-bold mb-3">We Are Hiring for our Company</div>
              <div className="list-wrapper">
                <ul className="list-unstyled d-flex flex-column" style={{ gap: '12px' }}>
                  <li>
                    <div className="item small fw-medium text-white d-flex align-items-center gap-2">
                      <span className="bg-white bg-opacity-10 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '26px', height: '26px' }}>1</span>
                      <span className="item-name">Create your profile</span>
                    </div>
                  </li>
                  <li>
                    <div className="item small text-white text-opacity-75 d-flex align-items-center gap-2">
                      <span className="bg-white bg-opacity-10 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '26px', height: '26px' }}>2</span>
                      <span className="item-name">Verify your identity</span>
                    </div>
                  </li>
                  <li>
                    <div className="item small text-white text-opacity-75 d-flex align-items-center gap-2">
                      <span className="bg-white bg-opacity-10 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '26px', height: '26px' }}>3</span>
                      <span className="item-name">Download interview app</span>
                    </div>
                  </li>
                  <li>
                    <div className="item small text-white text-opacity-75 d-flex align-items-center gap-2">
                      <span className="bg-white bg-opacity-10 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '26px', height: '26px' }}>4</span>
                      <span className="item-name">Interview at your pace</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bottom-sec">
              <div className="title small text-white text-opacity-50">Experience <span className="bg-theme7 fw-medium text-dark rounded px-2 py-1">Smart Interviews</span> Powered by AI</div>
            </div>

            {/* <div className='slider-wrapper pt-5 mt-auto'>
                  <Slider {...settings}>
                    <div className='testimonial-cards rounded-4 p-3'>
                      <p className='description'>Experience a live interview and seize the chance to secure a job offer.</p>
                      <div className='d-flex align-items-center gap-2'>
                        <div className='img-chip'>
                          <img className='img-fluid rounded-2 border border-light' src={require('../assets/Avatar.png')} alt='User' />
                        </div>
                        <div className='chip-details'>
                          <div className='user-name fw-bold'>VirtualEmployee</div>
                          <div className='user-profile'></div>
                        </div>
                      </div>
                    </div>
                    <div className='testimonial-cards rounded-4 p-3'>
                      <p className='description'>Grab your chance to earn the best salaries the market has to offer.</p>
                      <div className='d-flex align-items-center gap-2'>
                        <div className='img-chip'>
                          <img className='img-fluid rounded-2 border border-light' src={require('../assets/Avatar.png')} alt='User' />
                        </div>
                        <div className='chip-details'>
                          <div className='user-name fw-bold'>VirtualEmployee</div>
                          <div className='user-profile'></div>
                        </div>
                      </div>
                    </div>
                    <div className='testimonial-cards rounded-4 p-3'>
                      <p className='description'>Enhance and evaluate your skills using the premier self-assessment tool in the industry.</p>
                      <div className='d-flex align-items-center gap-2'>
                        <div className='img-chip'>
                          <img className='img-fluid rounded-2 border border-light' src={require('../assets/Avatar.png')} alt='User' />
                        </div> 
                         <div className='chip-details'>
                          <div className='user-name fw-bold'>VirtualEmployee</div>
                          <div className='user-profile'></div>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div> */}
          </div>
        </div>
        <div className='right-section d-flex align-items-center justify-content-center'>
          <div className="info-wrapper bg-white rounded-4 shadow">

            {/* Card Header: Logo + Secure Badge */}
            <div className="signin-card-header text-center mb-4">
              <div className="brand-lockup d-inline-flex align-items-center gap-1 mb-3">
                <span className="fw-bold" style={{ fontSize: '22px', letterSpacing: '-0.5px', color: '#2d0f7a' }}>{process.env.REACT_APP_COMPANY === 'virtual' ? 'Virtual' : 'Teck'}</span>
                <span className="fw-bold" style={{ fontSize: '22px', letterSpacing: '-0.5px', color: '#00d4b8' }}>{process.env.REACT_APP_COMPANY === 'virtual' ? 'Employee' : 'Valley'}</span>
              </div>
              <div className="d-block"></div>
              <div className="d-inline-flex align-items-center gap-1 rounded-pill px-3 py-1" style={{ background: 'rgba(0,212,184,0.1)', border: '1px solid rgba(0,212,184,0.35)' }}>
                <span style={{ fontSize: '11px', color: '#00a896', fontWeight: 500 }}>🔒 You're on a secure portal</span>
              </div>
            </div>

            {/* Job Title */}
            {jobTitle && (
              <div className="d-flex align-items-start gap-2 rounded-3 px-3 py-2 mb-3" style={{ background: '#f5f3ff', border: '1px solid #e0d9f9' }}>
                <i className="bi bi-briefcase-fill text-primary mt-1" style={{ fontSize: '13px' }}></i>
                <div>
                  <div className="fs-12 text-muted lh-1 mb-1">Applying for</div>
                  <div className="fw-semibold text-dark" style={{ fontSize: '13px' }}>
                    {jobTitle}{reqId ? ` — VEREQ${reqId}` : ""}
                  </div>
                </div>
              </div>
            )}

            {/* Sign In Section */}
            <div className="signin-section rounded-3 p-3 mb-3" style={{ background: '#f8f9fa', border: '1px solid #e9ecef' }}>
              <div className="small text-muted mb-2 fw-medium">Already have an account?</div>
              <button
                type="button"
                className="w-100 d-flex align-items-center justify-content-center gap-2 rounded-3 border py-2 px-3 bg-white fw-medium text-dark"
                style={{ fontSize: '13px', cursor: 'pointer', borderColor: '#d0d5dd', transition: 'border-color 0.2s, box-shadow 0.2s' }}
                onClick={handleSignIn}
                onMouseOver={e => { e.currentTarget.style.borderColor = '#6c2fd9'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(108,47,217,0.08)'; }}
                onMouseOut={e => { e.currentTarget.style.borderColor = '#d0d5dd'; e.currentTarget.style.boxShadow = 'none'; }}
              >
                <img src={googleIcon} alt="Google" style={{ width: '15px' }} />
                Sign In with Google
              </button>
            </div>

            {/* Divider */}
            <div className="divider my-3">
              <span>OR</span>
            </div>

            {/* Sign Up Section */}
            <div className="mb-1">
              <div className="fw-bold text-dark mb-1" style={{ fontSize: '18px' }}>Create your account</div>
              <div className="fs-12 text-secondary mb-3">Join the smart interview experience in minutes</div>
            </div>

            <p className="fs-12 text-secondary mb-3">
              By continuing, you agree to the
              <Link to="#" target="_blank" className="btn-link text-decoration-none"> Terms and Conditions </Link>
              and
              <Link to="#" target="_blank" className="btn-link text-decoration-none"> Privacy Policy </Link>
              of {process.env.REACT_APP_FOOTER_NAME}
            </p>

            <button
              type="button"
              className="w-100 d-flex align-items-center justify-content-center gap-2 rounded-3 border-0 fw-semibold text-white"
              style={{
                height: '46px',
                fontSize: '14px',
                cursor: 'pointer',
                background: 'linear-gradient(135deg, #6c2fd9 0%, #00d4b8 100%)',
                boxShadow: '0 4px 14px rgba(108,47,217,0.3)',
                transition: 'opacity 0.2s, box-shadow 0.2s',
              }}
              onClick={handleGoogleSignIn}
              onMouseOver={e => { e.currentTarget.style.opacity = '0.92'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(108,47,217,0.4)'; }}
              onMouseOut={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.boxShadow = '0 4px 14px rgba(108,47,217,0.3)'; }}
            >
              <img src={googleIcon} alt="Google" style={{ width: '18px', filter: 'brightness(0) invert(1)' }} />
              Sign up with Google
            </button>

          </div>
        </div>
      </div>

      {/* Instruction Modal */}
      <Modal centered show={showInstructionModal} backdrop="static" keyboard={false} size="lg" contentClassName="rounded-3">
        <Modal.Header className="border-bottom pb-3">
          <Modal.Title className="fs-6 fw-bold">How to Register &amp; Get Started with Your Interview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-3">
          <div className="d-flex flex-column flex-md-row gap-4">

            {/* Stage 1 */}
            <div className="flex-fill">
              <div className="d-flex align-items-center gap-2 mb-2">
                <span className="badge bg-primary rounded-pill px-2 py-1" style={{ fontSize: '11px' }}>Stage 1</span>
                <span className="fw-semibold" style={{ fontSize: '14px', color: '#111827' }}>Registration</span>
              </div>
              <p className="mb-2" style={{ fontSize: '13px', color: '#6B7280' }}>During registration you will be required to:</p>
              <ul className="mb-0 ps-3 d-flex flex-column" style={{ gap: '8px', listStyleType: 'disc' }}>
                <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>Capture your photograph in a well-lit environment.</li>
                <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>Upload your updated CV <span className="text-muted">(Doc, Docx or PDF)</span>.</li>
                <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>Verify your phone number.</li>
              </ul>
            </div>

            <div className="vr d-none d-md-block" style={{ opacity: '0.15' }}></div>

            {/* Stage 2 */}
            <div className="flex-fill">
              <div className="d-flex align-items-center gap-2 mb-2">
                <span className="badge bg-success rounded-pill px-2 py-1" style={{ fontSize: '11px' }}>Stage 2</span>
                <span className="fw-semibold" style={{ fontSize: '14px', color: '#111827' }}>Interview with Sheela AI</span>
              </div>
              <p className="mb-2" style={{ fontSize: '13px', color: '#6B7280' }}>Conducted only on a <strong>Windows laptop/desktop</strong> with a camera. Please ensure:</p>
              <ul className="mb-0 ps-3 d-flex flex-column" style={{ gap: '8px', listStyleType: 'disc' }}>
                <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>Download and install the latest version of the desktop software.</li>
                <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>Grant microphone and camera permissions on your laptop/desktop.</li>
                <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>Keep a fully charged mobile phone with an active internet connection <span className="text-muted">(required for anti-cheating measures)</span>.</li>
              </ul>
            </div>
          </div>

          <hr className="my-3" style={{ opacity: '0.12' }} />

          {/* Key Notes */}
          <div className="mb-3">
            <div className="fw-semibold mb-2" style={{ fontSize: '13px', color: '#111827' }}>Key Notes</div>
            <ul className="mb-0 ps-3 d-flex flex-column" style={{ gap: '6px', listStyleType: 'disc' }}>
              <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>You can start your interview immediately after completing registration.</li>
              <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>If you need more time, rescheduling is allowed <strong>only once</strong>.</li>
              <li style={{ fontSize: '13px', color: '#374151', lineHeight: '1.55' }}>The interview must be taken on a Windows laptop/desktop; however, a mobile phone is <strong>mandatory</strong> for monitoring purposes.</li>
            </ul>
          </div>

          {/* Need Help */}
          <div className="rounded-3 px-3 py-2" style={{ backgroundColor: '#F0F9FF', border: '1px solid #BAE6FD' }}>
            <span className="fw-semibold me-1" style={{ fontSize: '13px', color: '#0369A1' }}>Need Help?</span>
            <span style={{ fontSize: '13px', color: '#374151' }}>Contact <strong>Rehmat</strong> at <strong>8076669690</strong>, Monday to Saturday, 10:00 AM – 7:00 PM (IST).</span>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top pt-3">
          <Button variant="primary" onClick={() => setShowInstructionModal(false)}>I Understand</Button>
        </Modal.Footer>
      </Modal>
      {/* Instruction Modal */}
      {/* Warning Modal! */}
      <Modal centered show={alertshow} backdrop="static" keyboard={false} contentClassName="rounded-0 rounded-bottom text-center">
        <Modal.Body className='border-5 border-top border-primary p-4 p-md-5'>
          <div className='mx-auto' style={{ maxWidth: '320px' }}>
            <div className='text-warning mb-3 lh-1'><i className="bi bi-exclamation-circle h1 lh-1"></i></div>
            {/* <div className='text-secondary mb-3'>You need to contact your recruiter to schedule your interview, and then you can complete this registration process.</div> */}
            <div className='text-secondary mb-3'>To complete your registration, please use the same email address that your HR used to schedule your interview.</div>
            <Button variant="primary" onClick={onCloseAlert} className="px-4">OK</Button>
          </div>
        </Modal.Body>
      </Modal>

      <GooglePopupOverlay
        show={popupOpened}
        onCancel={() => setPopupOpened(false)}
      />
      {/* Warning Modal! */}
      <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} theme="colored" />
    </div>
  );
};

export default Signin;